import api from '../../services/api';
import { Recurso } from '../imponibles/imponiblesAPI';

export interface SearchedImponible {
  nro_rodado?: string;
  cuenta?: string;
  nro_comercio?: string;
  nro_contrib?: string;
  nro_inmueble?: string;
  tipo: string;
  marca: string;
  modelo: string;
  anio: string;
  dominio?: string;
  nro_sepult?: string;
  par_catastral?: string;
  cuit?: string;
  motor: null;
  carroceria: null;
  cilindrada: string;
  cod_deleg: string;
  observaciones: null;
  multipr1: null;
  multipr2: string;
  multipr3: string;
  fecha_alta: Date;
  fecha_baja: null;
  mot_baja: null;
  resp_pago: string;
  dp_cod_calle: string;
  dp_calle: string;
  dp_nro: string;
  dp_nro_med: null;
  dp_piso: null;
  dp_dept: null;
  dp_cod_pos: null;
  dp_cod_postal: string;
  dp_cod_loc: string;
  dp_cod_pro: string;
  dp_detalle: null;
  fecha_compra: Date;
  fecha_patent: null;
  dominio_actual: string;
  inciso: string;
  tipo_combus: null;
  categoria: string;
  fecha_ult_ddjj: null;
  fecha_tributa: null;
  uso: string;
  peso: string;
  carga: string;
  recupe: null;
  nacionalidad: string;
  motor_marca: null;
  motor_serie: null;
  chasis: null;
  valuacion: string;
  vtv: null;
  vtv_vto: null;
  seguro: null;
  seguro_vto: null;
  fr_cod_loc: null;
  fr_cod_pro: null;
  fecha_venta: null;
  cod_barrio: null;
  dp_cod_barrio: null;
  dp_lateral1: null;
  dp_lateral2: null;
  dp_mza: null;
  dp_blk: null;
  dp_esc: null;
  codigo_mtm: string;
  to_visible: string;
  to_operable: string;
  audit_usuario_alta: null;
  audit_fecha_alta: null;
  audit_usuario_modi: null;
  audit_fecha_modi: null;
  recursos: Recurso[];
  cuim?: string;
}

export interface SearchImponiblePayload {
  tipo: string;
  buscar: string;
}
async function searchImponible(data: SearchImponiblePayload) {
  const response = await api<SearchedImponible>(
    'POST',
    `imponibles/buscar`,
    data
  );

  return response;
}

const offlineImponiblesAPI = {
  searchImponible,
};

export default offlineImponiblesAPI;
